/**
 * Whether each routed-away item's hand-off email arrived, read from its
 * timeline (case round, finding 1). Moved out of the Routed away page in the
 * tabs round: the shell reads it once so the "More" drop-down can flag an
 * undelivered send while Routed away is out of sight, and hands the same
 * outcomes to the page through the Outlet context.
 */
import { useMemo } from 'react';
import type { DoorThreadRead } from '../../services/qcpInvestigations';
import { deliveryOutcome, type DeliveryOutcome } from './deliveryView';
import { useThreadTimelines } from './useThreadTimelines';

/**
 * Whether each item's hand-off email arrived, read from its timeline. Until
 * an item's timeline lands the row claims nothing.
 */
export function useDeliveryOutcomes(threads: DoorThreadRead[]): Record<string, DeliveryOutcome | null> {
  const timelines = useThreadTimelines(threads);
  return useMemo(() => {
    const out: Record<string, DeliveryOutcome | null> = {};
    for (const t of threads) {
      if (timelines[t.id]) out[t.id] = deliveryOutcome(t, timelines[t.id]);
    }
    return out;
  }, [threads, timelines]);
}
